import { z } from 'zod';

export const DataSetSchema = z
  .object({
    name: z
      .string({ message: 'Name is required' })
      .regex(/^[a-zA-Z0-9 ]+$/, { message: 'Name must not contain special characters' }),
    datasource_type: z.enum([
      'naive',
      'website',
      'book',
      'laws',
      'manual',
      'one',
      'paper',
      'presentation',
      'qa',
      'resume',
      '_table',
      'blank'
    ]),
    parser_config: z
      .object({
        url: z
          .string()
          .transform((val) => (val.startsWith('http') ? val : `https://${val}`))
          .refine(
            (val) => {
              const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
              return urlPattern.test(val);
            },
            { message: 'Invalid URL' }
          )
          .optional(),
        scrap_website: z.boolean().optional(),
        exclude_urls: z.any().optional(),
        chunk_token_num: z.any().optional(),
        delimiter: z.string().optional(),
        layout_recognize: z.any().optional(),
        raptor: z
          .object({
            use_raptor: z.any().optional(),
            max_cluster: z.any().optional(),
            max_token: z.any().optional(),
            prompt: z.any().optional(),
            random_seed: z.any().optional(),
            threshold: z.any().optional()
          })
          .optional()
      })
      .optional()
  })
  .superRefine((values, ctx) => {
    if (values.datasource_type === 'naive') {
      if (!values?.parser_config?.chunk_token_num) {
        ctx.addIssue({
          message: 'Chunk token is required',
          code: z.ZodIssueCode.custom,
          path: ['parser_config', 'chunk_token_num']
        });
      }
      // if (!values.parser_config.raptor?.use_raptor) {
      //   ctx.addIssue({
      //     message: 'use raptor is required',
      //     code: z.ZodIssueCode.custom,
      //     path: ['parser_config', 'raptor', 'use_raptor']
      //   });
      // }
      if (!values.parser_config?.raptor?.max_cluster) {
        ctx.addIssue({
          message: 'Max cluster is required',
          code: z.ZodIssueCode.custom,
          path: ['parser_config', 'raptor', 'max_cluster']
        });
      }
      if (!values.parser_config?.raptor?.max_token) {
        ctx.addIssue({
          message: 'Max token is required',
          code: z.ZodIssueCode.custom,
          path: ['parser_config', 'raptor', 'max_token']
        });
      }
      if (!values.parser_config?.raptor?.prompt) {
        ctx.addIssue({
          message: 'prompt is required',
          code: z.ZodIssueCode.custom,
          path: ['parser_config', 'raptor', 'prompt']
        });
      }
      if (!values.parser_config?.raptor?.random_seed) {
        ctx.addIssue({
          message: 'random seed is required',
          code: z.ZodIssueCode.custom,
          path: ['parser_config', 'raptor', 'random_seed']
        });
      }
      if (!values.parser_config?.raptor?.threshold) {
        ctx.addIssue({
          message: 'Threshold is required',
          code: z.ZodIssueCode.custom,
          path: ['parser_config', 'raptor', 'threshold']
        });
      }
    }

    if (values.datasource_type === 'website') {
      if (!values.parser_config?.url) {
        ctx.addIssue({
          message: 'Url is required',
          code: z.ZodIssueCode.custom,
          path: ['parser_config', 'url']
        });
      }
    }
  });

export type DataSetFormRequest = z.infer<typeof DataSetSchema>;
